<template>
  <v-row dense>
    <v-col
      v-if="categoryId"
      class="text-h6"
    >
      Core Products
    </v-col>
    <v-spacer />
    <v-col cols="auto">
      <v-btn
        v-if="categoryId"
        icon
        @click="add"
      >
        <v-icon color="primary"> add </v-icon>
      </v-btn>
      <!-- <v-select
        v-else
        :items="categories"
        v-model="filterCategoryId"
        hide-details
        clearable
        outlined
        item-value="id"
        item-text="name"
        label="Filter Category"
        dense
      /> -->
    </v-col>
    <v-col cols="12">
      <v-card
        :loading="loading"
        class="pa-0"
      >
        <v-card-text class="pa-0">
          <v-data-table
            :items="productsToShow"
            :headers="headers"
            class="row-pointer"
            hide-default-footer
            disable-pagination
            :group-by="!categoryId ? 'category.id' : undefined"
            mobile-breakpoint="0"
            @click:row="rowClick"
          >
            <template #[`group.header`]="{ items, isOpen, toggle }">
              <th colspan="100%">
                <v-icon @click="toggle">
                  {{ isOpen ? 'mdi-minus' : 'mdi-plus' }}
                </v-icon>
                {{ items[0].category.name }}
              </th>
            </template>

            <template #[`item.alert`]="{ item }">
              <v-tooltip bottom>
                <template #activator="{ on, attrs }">
                  <v-icon
                    v-if="missingOptions(item)"
                    small
                    v-bind="attrs"
                    color="error"
                    v-on="on"
                  >
                    error
                  </v-icon>
                </template>
                <span class="px-2"> Options not setup </span>
              </v-tooltip>
            </template>
            <template #[`item.blankCanvasTemplate.published`]="{ item }">
              <v-icon
                :color="
                  item.blankCanvasTemplate && item.blankCanvasTemplate.published
                    ? 'success'
                    : 'error'
                "
              >
                wifi
              </v-icon>
            </template>
            <template #[`item.isCategoryDefault`]="{ item }">
              <v-icon
                v-if="item.isCategoryDefault"
                color="success"
              >
                mdi-check
              </v-icon>
            </template>
            <template #[`item.allowTemplateCreation`]="{ item }">
              <v-icon
                v-if="item.allowTemplateCreation"
                color="success"
              >
                mdi-check
              </v-icon>
            </template>
            <template #[`item.resizeCoreProductIds`]="{ item }">
              <div
                v-for="id in item.resizeCoreProductIds"
                :key="id"
              >
                {{ product_name(id) }}
              </div>
            </template>
            <template #[`item.actions`]="{}">
              <v-icon>more_vert</v-icon>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
    <AddProduct
      @reload="loadData"
      @save="loadData"
    />
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import AddProduct from '@/components/products/Add';
import { sortBy, uniqBy, intersection, orderBy } from 'lodash';
export default {
  name: 'ListProducts',
  components: { AddProduct },
  props: { categoryId: { type: Number } },
  data() {
    return {
      loading: false,
      filterCategoryId: null
    };
  },

  computed: {
    headers() {
      const list = [
        { value: 'alert' },
        { value: 'blankCanvasTemplate.published' },
        { text: 'Name', value: 'name' },
        { text: 'Size', value: 'sizeDisplay' },
        { text: 'Category', value: 'category.name', hide: this.categoryId },
        { text: 'Category Default?', value: 'isCategoryDefault' },
        { text: 'Catalog?', value: 'allowTemplateCreation' },
        { text: 'Print Products', value: 'printProducts' },
        { text: 'Templates', value: 'templates' },
        { text: 'Resize To', value: 'resizeCoreProductIds', sortable: false },
        { text: '', value: 'actions', sortable: false }
      ];
      return list.filter((x) => !x.hide);
    },
    categories() {
      return sortBy(
        uniqBy(
          this.products.map((x) => x.category),
          'id'
        ),
        'name'
      );
    },
    productsToShow() {
      let list = this.products.filter((x) => x.active);
      if (this.filterCategoryId) {
        list = list.filter((x) => x.category.id === this.filterCategoryId);
      }
      return orderBy(
        list,
        [this.categoryId ? 'isCategoryDefault' : 'category.name', 'templates'],
        [this.categoryId ? 'desc' : 'asc', 'desc']
      );
    },
    missingOptions() {
      return (item) => {
        var options = uniqBy(
          this.connected(item.id)
            .flatMap((x) => x.options)
            .flatMap((x) => x.option),
          'id'
        );
        const excludeGroups = ['Handling Fee', 'Additional Options'];
        var optionGroups = uniqBy(
          options.flatMap((x) => x.group),
          'id'
        )
          .filter((x) => !excludeGroups.includes(x.name))
          .map((x) =>
            Object.assign(x, {
              optionIds: options.filter((y) => y.group.id === x.id).map((y) => y.id)
            })
          )
          .map((x) =>
            Object.assign(x, {
              hasDefault: !!intersection(item.optionDefaults, x.optionIds).length
            })
          );
        return !!optionGroups.filter((x) => !x.hasDefault).length;
      };
    },
    ...mapGetters({
      products: 'products/list',
      product_name: 'lookup/product_name',
      connected: 'print/connected'
    })
  },
  watch: {
    categoryId(val, oldVal) {
      if (val && oldVal && val !== oldVal) {
        this.loadData();
      }
    }
  },

  async mounted() {
    this.loadData();
  },

  methods: {
    loadData() {
      this.loading = true;
      Promise.all([
        this.categoryId
          ? this.$store.dispatch('products/getByCategory', this.categoryId)
          : this.$store.dispatch('products/getAll'),
        this.$store.dispatch('print/getAllProducts')
      ])
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rowClick(item) {
      this.$router.push({ path: `/products/${item.id}` });
    },

    add() {
      this.$bus.$emit(this.$enums.EVENT_BUS_EVENTS.ADD_CORE_PRODUCT_SHOW, {
        categoryId: this.categoryId
      });
    }
  }
};
</script>
